import React, { useEffect, useState } from "react";

import { Box, Button, TextField } from "@mui/material";
import { postMessage } from "../../Model/DeclaratorModel";

const Announcement = ({socketDeclarator,message}) => {



  const [announcement,setPostAnouncement] = useState("")

  const handleClick = async () => {

    const nextLotData = async () => {
      const results = await postMessage(announcement);
      if(results === "SUCCESS"){
        socketDeclarator.emit("postAnnouncement", {
          message: announcement, });
        }
      }
  
    nextLotData().catch(console.error);

  
  }

  useEffect(() => {
    try {
      setPostAnouncement(message[0].announcement)
    } catch (error) {
      
    }
    // console.log("message: ",message)
  },[message])

  return (
<div style={{height: "40%"}}>
    <Box style={{ padding: 10 }}>
       <TextField
        fullWidth
        margin="normal"
        id="outlined-multiline-static"
        label="Announcement"
        multiline
        rows={4}
        InputLabelProps={{
          shrink: true
        }}
        defaultValue={announcement}
        name="postAnounce"
        onChange={(e) => setPostAnouncement(e.target.value)}
        variant="outlined"
        />

<Button
            fullWidth
            style={{ margin: 2 }}
            variant="contained"
            color="primary"
            onClick={() => handleClick()}
          >
            Announce
           
          </Button>

   </Box>
   </div>
  );
};

export default Announcement;